import React from 'react'
import ProjectStep from "../components/ProjectStep";
import {generatePath} from "react-router-dom";
import Form, {FormInputComponent} from "../../../components/form/Form";
import TeamBlueprint from "../components/TeamBlueprint";
import {Input} from "antd";

export default class TeamExperienceStep extends ProjectStep {
    static TranslationKey = 'disciplines_skills_step';

    static path = '/experience';
    static slug = 'experience';

    static HandleUnauthorized = false;

    static Optional = false;

    static ValidationMethodName = 'validateExperience';

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            isLoading: false
        }
    }


    async componentDidMount() {
        await super.componentDidMount();
    }

    /**
     * The continue & back buttons
     */
    static showFormButtons() {
        return false
    }

    getStepName() {
        return false
    }

    /**
     * The subtitle shown on the form
     */
    getStepSubtitle() {

        return ``;
    }

    static hasCompleted(project) {
        return project.validateTeamExperience();
    }

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(project) {
        return project.hasSelectedExperience()
    };

    static getPath(project) {
        let projectId = TB.isObject(project) ? project.id : project;

        return generatePath(`${TB.routes().clientProjectSetup}${this.path}`, {
            projectId
        })
    }


    render() {

        return (
            <div className="flex flex-col items-stretch gap-4">
                <TeamBlueprint>
                    <p className="px-4 py-3 flex flex-row items-center justify-center gap-2">
                        <i className="fas fa-check-circle text-success text-[15px]"/>
                        <span>
                            Industry experience has been captured. Last step! Let us know if any preference
                            for # <span className="font-semibold">years of experience</span> for your team.
                        </span>
                    </p>
                </TeamBlueprint>
                <div className="wizard-form-step project-team-step">
                    <Form
                        ref={this.formRef}
                        showRequired
                        title={null}
                        subtitle={null}
                        submitButton={false}
                        onSubmit={null}
                        background="transparent"
                        model={this.props.project}
                        onChange={this.props.onChange}
                        fields={[]}
                        minimal
                        isDisabled={this.props.isDisabled}>
                        <div className="flex flex-col items-stretch gap-4">

                            <div className="flex flex-col items-stretch gap-6 bg-white">

                                <div className="flex items-stretch relative project-skills-step flex-col gap-6">
                                    <div className="flex flex-row justify-between items-center pb-5">
                                        <div>
                                            <p className="text-lg uppercase inline text-black font-semibold">
                                                Team Experience
                                            </p>
                                            <p className="text-sm text-left text-black">
                                                We've defaulted to the most common level. You can edit below.
                                            </p>
                                        </div>
                                        {!this.props.shouldBeRedirected() && (
                                            <p className="flex flex-col gap-1 justify-center text-center">
                                            <span className="text-xs text-center text-black">
                                                Rather discuss on a call?
                                            </span>
                                                <span onClick={() => {
                                                    if (this.props.isDisabled) {
                                                        return
                                                    }
                                                    return this.props.goToNextStep()
                                                }}
                                                      className="clickable text-base underline font-semibold text-center text-primary">
                                                SKIP THIS STEP
                                            </span>
                                            </p>
                                        )}
                                    </div>

                                    <div className="flex flex-col gap-2">

                                        <div className="sm:flex flex-row -mx-2 mt-4">
                                            <FormInputComponent
                                                type="antd-input"
                                                fieldName="wants_junior_experience"
                                                value={this.props.project?.wants_junior_experience}
                                                disabled={this.props.isDisabled}
                                                label={false}
                                                className="w-full"
                                            >
                                                <Checkbox title="Accomplished" description="< 6 Years"/>
                                            </FormInputComponent>

                                            <FormInputComponent
                                                type="antd-input"
                                                fieldName="wants_intermediate_experience"
                                                value={this.props.project?.wants_intermediate_experience}
                                                disabled={this.props.isDisabled}
                                                label={false}
                                                className="w-full"
                                            >
                                                <Checkbox title="Advanced" description="6-10 Years"/>
                                            </FormInputComponent>

                                            <FormInputComponent
                                                type="antd-input"
                                                fieldName="wants_senior_experience"
                                                value={this.props.project?.wants_senior_experience}
                                                disabled={this.props.isDisabled}
                                                label={false}
                                                className="w-full"
                                            >
                                                <Checkbox title="Expert" description="11+ Years"/>
                                            </FormInputComponent>

                                        </div>

                                        <FormInputComponent
                                            type="antd-input"
                                            fieldName="has_experience"
                                            value={this.props.project.wants_intermediate_experience
                                                || this.props.project.wants_senior_experience
                                                || this.props.project.wants_junior_experience
                                            }
                                            required={true}
                                            validation={
                                                {
                                                    rules: {
                                                        hasExperience: function (model, value) {
                                                            if (!model.wants_intermediate_experience
                                                                && !model.wants_senior_experience
                                                                && !model.wants_junior_experience
                                                            ) {
                                                                return "Please select at least one"
                                                            }
                                                            return true
                                                        },
                                                    }
                                                }
                                            }
                                            disabled={this.props.isDisabled}
                                            label={false}
                                            className="my-0 p-0">
                                            <Input type="hidden"/>
                                        </FormInputComponent>

                                        {/*<FormInputComponent*/}
                                        {/*    fieldName="min_score"*/}
                                        {/*    type="min_experience"*/}
                                        {/*    label={false}*/}
                                        {/*    disabled={this.props.isDisabled}*/}
                                        {/*    help={!this.props.isReadOnly && 'Highlight the minimum level of experience you are comfortable with (at least one level must be selected)'}*/}
                                        {/*    validationErrors={{isDefaultRequiredValue: TB.trans('validation.required', {attribute: 'minimum level of experience'})}}*/}
                                        {/*    required={true}*/}
                                        {/*    value={this.props.project.min_score || ''}*/}
                                        {/*/>*/}
                                    </div>
                                    <div className="flex flex-col mt-2">
                                        <p className="text-sm">
                                            Add note regarding the team roles, skills or experience <span
                                            className="italic">(Optional)</span>
                                        </p>
                                        <div className="mt-[-10px]">
                                            <FormInputComponent
                                                fieldName="expertise_notes"
                                                value={this.props.project.expertise_notes || ''}
                                                type="editor"
                                                disabled={this.props.isDisabled}
                                                maxLength={10000}
                                                rows={8}
                                                label={false}
                                                required={false}
                                                placeholder="Type your note here."/>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="mt-5 flex flex-col items-stretch">
                                {this.props.children}
                            </div>
                        </div>
                    </Form>

                </div>
            </div>
        )
    }
}

const Checkbox = ({ name, title, description, disabled, onChange, value }) => {
    return (
        <label htmlFor={name} className="w-full">
            <input type="checkbox" checked={value} name={name} id={name} onChange={e => onChange(e.target.checked)} />

            <div
                className={TB.mapClass("experience-tile-select relative flex my-3 sm:my-0 items-center border mx-2 gap-3 px-4 py-3 rounded-lg flex-1 disabled:pointer-events-none", {
                    selected: value,
                    disabled,
                    clickable: !disabled,
                })}
            >
                {value ?
                    <i className="fas fa-check-square text-success" />
                    : <i className="far fa-square" />
                }

                <div className="flex gap-1 flex-col">
                    <h6 className="font-bold mb-0">{title}</h6>
                    <p className="text-sm mb-0">{description}</p>
                </div>
            </div>
        </label>
    )
}